"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var confirmationDialog_1 = __importDefault(require("relements/build/esm/decorators/confirmationDialog"));
var api_1 = require("@src/api");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var api_2 = require("@src/containers/BusinessManager/store/api");
var actions_1 = require("@src/containers/BusinessManager/store/actions");
var BotPromptTriggerSettings_1 = __importDefault(require("@src/containers/BusinessManager/components/BotPromptTriggerSettings"));
var TabContainer_1 = __importDefault(require("../../components/TabContainer"));
var utils_1 = require("../../utils");
var constants_1 = require("../../constants");
var maps_1 = require("./maps");
require("./BotPrompt.scss");
var BotPrompt = function (_a) {
    var activateConfirmationDialog = _a.activateConfirmationDialog;
    var _b = react_1["default"].useState([]), triggerSettings = _b[0], setTriggerSettings = _b[1];
    var _c = react_1["default"].useState(false), isEdited = _c[0], setIsEdited = _c[1];
    var _d = react_1["default"].useState(false), isLoaderActive = _d[0], setIsLoaderActive = _d[1];
    var _e = react_redux_1.useSelector(maps_1.stateToProps), businessId = _e.businessId, activePartners = _e.activePartners;
    react_1["default"].useEffect(function () {
        setIsLoaderActive(true);
        api_2.getBusinessTriggerSettings(businessId)
            .then(function (_a) {
            var success = _a.success, body = _a.body, error = _a.error;
            setIsLoaderActive(false);
            if (!success) {
                maps_1.createAlert(error || 'Error occurred while fetching trigger settings', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return;
            }
            setTriggerSettings(body);
        })["catch"](function (error) {
            setIsLoaderActive(false);
            api_1.captureException(error);
        });
    }, []);
    var handleOnChange = function (newSettings) {
        setTriggerSettings(newSettings);
        setIsEdited(true);
    };
    var handleOnSave = function () {
        if (!isEdited)
            return;
        setIsLoaderActive(true);
        var data = {
            bot_prompt_trigger_list: triggerSettings,
        };
        api_2.savePromptTriggerData(businessId, data)
            .then(function (_a) {
            var success = _a.success, body = _a.body, error = _a.error;
            setIsLoaderActive(false);
            if (!success) {
                maps_1.createAlert(error || 'Failed to save!', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return;
            }
            setTriggerSettings(body); // To set the updated ID of the triggers
            maps_1.createAlert('Successfully saved!', null, MogamboConstants_1.AlertTypes.POSITIVE);
            setIsEdited(false);
        })["catch"](function (error) {
            setIsLoaderActive(false);
            api_1.captureException(error);
        });
    };
    var handlePromptTransfer = react_1["default"].useCallback(function () {
        if (!utils_1.canTransfer([constants_1.TRANSFER_TYPE.TRIGGER]))
            return;
        if (isEdited) {
            maps_1.createAlert('Please save all the changes before publishing', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        activateConfirmationDialog({
            title: "Do you want to publish all Prompt Triggers?",
            message: 'The triggers will be published to Production.',
            positiveText: 'Publish',
            negativeText: 'Cancel',
            themed: true,
        }, function (success) { return __awaiter(void 0, void 0, void 0, function () {
            var headers, IdsToTransfer, transferApiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!success)
                            return [2 /*return*/];
                        headers = utils_1.getBusinessAuditHeaders(businessId, 'transfer_bot_prompts', activePartners.map(function (partner) { return partner.name; }));
                        IdsToTransfer = triggerSettings.map(function (trigger) { return trigger.id; });
                        return [4 /*yield*/, actions_1.transferPromptTriggers(IdsToTransfer, headers)];
                    case 1:
                        transferApiResponse = _a.sent();
                        if (!transferApiResponse) {
                            maps_1.createAlert('Publish failed! Try again', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        maps_1.createAlert('Publish successful! The changes will reflect on the Apps within 30 minutes to 1 hour.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        return [2 /*return*/];
                }
            });
        }); });
    }, [businessId, activePartners, triggerSettings, isEdited]);
    return (react_1["default"].createElement(TabContainer_1["default"], { title: "Bot Prompt Triggers", marginTop: 54, isSaveDisabled: !isEdited, isLoaderActive: isLoaderActive, onSave: handleOnSave },
        react_1["default"].createElement(BotPromptTriggerSettings_1["default"], { isV2: true, value: triggerSettings, onChange: handleOnChange, onPromptTransfer: handlePromptTransfer, triggerDataEdited: isEdited })));
};
exports["default"] = confirmationDialog_1["default"]()(BotPrompt);
